import Header from "../../components/header"
import {
    TitleContent,
    ContentLeft,
    Trending,
    TrendingItem,
    TrendingLink,
    TitleNews,
    TitleTimeHome,
    FlexLayout,
    BoxHeader,
    BoxTitle,
    LatestNewBox,
    BorderLine,
    TitleBoxWrap,
    
} from './homeElements'
import {MyContainer} from '../../components/common/MyContainer'
import { useEffect, useState } from "react"
import Grid from '@material-ui/core/Grid';
import Banner from '../../components/banner'
import CategoryBox from "../../components/categoryBox"
import HighlightBox from "../../components/highlightBox"
import MostViewBox from '../../components/mostViewBox'
import Footer from "../../components/footer";
import FocusBox from "../../components/focusBox";
import NewsNewBox from "../../components/newsNewBox";


const Home = () => {
    const [time, setTime] = useState({})

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        const date = new Date();
        const dowArr = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']

        setTime({
            dow: dowArr[date.getDay()],
            day: date.getDate(),
            month: date.getMonth()+1,
            year: date.getFullYear()
        })
    }, [])
  
    return (
        <>
            <Header />
                <MyContainer>
                    <TitleContent className='hide-on-mobile-tablet'>
                        <ContentLeft>
                            <Trending>
                                <TrendingItem>
                                    <TrendingLink to='/'>Quỹ vắc xin phòng chống COVID-19</TrendingLink>
                                </TrendingItem>
                                <TrendingItem>
                                    <TrendingLink to='/'>Hiến kế 'TP.HCM nâng tầm quốc tế'</TrendingLink>
                                </TrendingItem>
                                <TrendingItem>
                                    <TrendingLink to='/'>Euro 2020</TrendingLink>
                                </TrendingItem>
                            </Trending>
                            <TitleNews to='/'>Tin mới nhất</TitleNews>
                        </ContentLeft>
                        <TitleTimeHome>{`${time.dow}, ngày ${time.day} tháng ${time.month} năm ${time.year}`}</TitleTimeHome>
                    </TitleContent>
                    <BoxTitle to='/' style={{marginTop: '5px', display: 'block', marginBottom: '5px'}} className='hide-on-pc hide-on-tablet'>Tin mới nhất</BoxTitle>
                    <Grid container>
                        <Grid  item lg={8} md={12}>
                            <FocusBox />
                        </Grid>

                        <Grid className="hide-on-mobile-tablet" item md={4}>
                            <FlexLayout style={{flexDirection: 'column'}}>
                                <iframe title="ads1" id="iframe-jmgdr8wl-kqc8cxe3" src="https://static-cmsads.admicro.vn/cmsads/2021/06/Vene-1624619188170.x-zip-compre/VeneziaBeach.html?link=https%3A%2F%2Flg1.logging.admicro.vn%2Fcpx_cms%3Fdmn%3Dhttps%253A%252F%252Ftuoitre.vn%252F%26zid%3Djmgdr8wl%26pli%3Dkqc8cwut%26cmpg%3Dkhobowu0%26items%3Dkqc8cxe3%26cat%3D%252Fhome%252F%26cov%3D1%26pgid%3D1625573809218875632%26uid%3D1625027409090381074%26re%3Dhttps%253A%252F%252Fveneziabeach.vn%252F%253Futm_source%253DLDN-gigan%2526utm_medium%253DTuoiTreHomeRightBanner1PC%2526utm_campaign%253DGiaiDoan1%2526utm_content%253DTuoiTreHomeRightBanner1PC" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" width="300" height="250" style={{display: 'block', marginLeft: 'auto'}}></iframe>
                                <iframe title="ads2" style={{marginTop: '8px', marginLeft: 'auto'}} src="https://cdnstoremedia.com/adt/banners/nam2015/4043/min_html5/thuongphamthuy/2021_07_05/300x250_t6-132/300x250_t6-132/300x250_t6-132.html?url=%2F%2Flg1.logging.admicro.vn%2Fadn%3Fdmn%3Dhttps%253A%252F%252Ftuoitre.vn%252F%26rid%3D885d2750-f8e7-4b3e-9c5a-981819b17c11120-60e450d7%26ctr%3D1.6051364364102483%26sspb%3D16051%26sspr%3D0.6262%26lsn%3D1625575615800%26ce%3D1%26lc%3D5%26cr%3D1625027409%26ui%3D2750274091907117133%26uuid%3De401684dc22bea82907ffa77362a622f%26bi%3D0%26cmpg%3D59178%26items%3D245881%26zid%3D483710%26pr%3D24601822830%26cid%3D-1%26tp%3D11%26tpn%3D4%26alg%3D10%26sspz%3D1897%26adc_cpa%3D1%26cov%3D1%26re%3Dhttps%253A%252F%252Fts.vhu.edu.vn%252F%253Futm_source%253Dadmicro_adx%2526utm_campaign%253Dadx%2526utm_content%253Dtuoitre.vn&amp;admid=adnzone_483710_0_245881&amp;vast=https%3A%2F%2Fsspapi.admicro.vn%2Fssp_request%2Fvideo%3Fu%3Dtuoitre.vn%252F%26z%3D483710%26p%3D1%26w%3D650%26h%3D300%26%26lsn%3De7f5e7dbbe6e473659161a3996e87ac7%26dgid%3D636b779a771444eb535cad65c0c6cdf4%26l%3D5%26loc%3D5%26i%3D2750274091907117133%26isdetail%3D0%26pid%3D%26tags%3D5%26adstype%3D%26vtype%3D8%26vid%3D%26bannerid%3D245881" width="300" height="250" frameBorder="0" scrolling="no"></iframe>
                            </FlexLayout>
                        </Grid>

                    </Grid>
                    <HighlightBox />
                    <Banner image="https://res.cloudinary.com/huyphamcloud/image/upload/v1625701961/tuoitre/980x-1624585976824_lhv5c9.jpg" />
                    <LatestNewBox>
                        <BorderLine />
                        <TitleBoxWrap>
                            <BoxHeader>
                                <BoxTitle  to='/'>Tin mới</BoxTitle>
                            </BoxHeader>
                        </TitleBoxWrap>
                        <NewsNewBox skip={15} _limit={32} />
                    </LatestNewBox>
                    <MostViewBox />
                    <CategoryBox ct1='thời sự' ct2='thế giới' rowfirst />
                    <CategoryBox ct1='pháp luật' ct2='kinh doanh' />
                    <CategoryBox ct1='nhịp sống trẻ' ct2='thể thao' rowfirst />
                    <CategoryBox ct1='văn hóa' ct2='giải trí' />
                    <CategoryBox ct1='giáo dục' ct2='công nghệ' rowfirst />
                    <CategoryBox ct1='khoa học' ct2='sức khỏe' />
                    <CategoryBox ct1='giả-thật' ct2='bạn đọc' rowfirst />
                    <CategoryBox ct1='du lịch' ct2='kinh doanh' />
                    
                </MyContainer>
            <Footer />
        </>
    )
}

export default Home
